import { Typography } from "@mui/material";

import { useContext, useEffect, useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ReactComponent as ChargerDevice } from "../../Assets/Icons/ChargerIcon.svg";
import { ReactComponent as TaxIcon } from "../../Assets/Icons/PercentIcon.svg";
import { ReactComponent as PowerIcon } from "../../Assets/Icons/PowerIcon.svg";
import { ReactComponent as WalletIcon } from "../../Assets/Icons/WalletIcon.svg";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import OnOffSlider from "../Common/OnOffSlider";

import TaxPercentages from "../../Helpers/TaxPercentages.json";
import BigButton from "../Common/BigButton";
import { TextFieldInput } from "../Common/TextFieldInput";
import { TextFieldSelect } from "../Common/TextFieldSelect";

export const ChargerForm = ({ data, handleDrawerClose }) => {

	const { ApiCall } = useContext(ApiContext);

	const { t } = useTranslation();

	const chargerName = String(data.id).padStart(4, "0");
	const maxPower = data?.max_power;
	const typeName = data?.type.name;
	const chargingPrice = data?.base_vat_price;
	const chargingTax = data?.vat_percentage || 0;
	const chargerStatus = data?.connector_status;
	const [chargerInUse, setChargerInUse] = useState(data?.in_use);
	const svgIcon = data?.type.icon;

	const strokeColor = ColorScheme.darkGrey;
	const iconHeight = 24;
	const iconWidth = 24;
	const strokeWidth = 1.25;

	const [price, setPrice] = useState(0);
	const [tax, setTax] = useState(null);

	const switchAvailability = () => {

		ApiCall("PUT", "client/charger/connector/" + data.id, {
			in_use: !chargerInUse
		})
			.then((res) => {
				setChargerInUse(res.in_use);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleSave = () => {

		ApiCall("PUT", "client/charger/connector/" + data.id, {
			base_vat_price: Number(price),
			vat_percentage: tax
		})
			.then((res) => {
				console.log(res);
				handleDrawerClose();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		if (chargingTax !== undefined && chargingTax !== null)
			setTax(chargingTax);
		if (chargingPrice !== undefined && chargingPrice !== null)
			setPrice(chargingPrice);
	}, []);

	return (
		<div
			style={{
				display: "flex",
				gap: "2px",
				flexDirection: "column",
				width: "100%",
				height: "100%"
			}}
		>
			<div
				style={{
					display: "flex"
				}}
			>
				<div style={{ flex: 1 }}>

					<Typography
						style={{
							fontSize: "26px",
							fontWeight: "bold",
							lineHeight: "40px",
							color: ColorScheme.primary
						}}
					>
						{chargerName}
					</Typography>
					<Typography
						style={{
							fontSize: "18px",
							fontWeight: "normal",
							lineHeight: "10px", // equal to fontSize to reduce the gap between row lines
							color: ColorScheme.darkGrey
						}}
					>
						{/* {t("charging." + String(chargerStatus).toLowerCase())} */}
						{chargerStatus}
					</Typography>
				</div>

				<OnOffSlider
					status={chargerInUse}
					action={switchAvailability}
				/>
			</div>

			<div style={{ height: "25px" }} />

			<div
				style={{
					display: "flex",
					flexDirection: "row",
					boxSizing: "border-box",
					borderRadius: "4px",
					padding: "20px",
					width: "100%",
					margin: "auto",
					border: "1px solid " + ColorScheme.darkGrey + ColorScheme.opacity25,
					backgroundColor: ColorScheme.lightGrey
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: isMobile ? undefined : "space-between",
						gap: "20px",
						width: "100%"
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							gap: "25px"
						}}
					>
						<ChargerDevice
							strokeWidth={strokeWidth}
							stroke={strokeColor}
							width={iconWidth}
							height={iconHeight}
						/>
						<Typography fontSize="18px">
							{data.charge_point_id}
						</Typography>
					</div>

					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							gap: "25px"
						}}
					>
						<PowerIcon
							strokeWidth={strokeWidth}
							stroke={strokeColor}
							width={iconWidth}
							height={iconHeight}
						/>
						<Typography fontSize="18px">
							{maxPower} {t("charging.kw_short")}
						</Typography>
					</div>

					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							gap: "25px"
						}}
					>
						<img
							width={iconWidth}
							alt="icon"
							src={`data:image/svg+xml;base64,${btoa(
								/* Ignore deprecated warning, only affects NodeJS */
								svgIcon
							)}`}
						/>

						{/* <Typography>{t("charging.charger_type")}</Typography> */}
						<Typography fontSize="18px">{typeName}</Typography>
					</div>
				</div>

			</div>

			<div style={{ height: "25px" }} />

			<div
				style={{
					display: "flex",
					flexDirection: "row",
					gap: "20px",
					boxSizing: "border-box"
				}}
			>
				<TextFieldInput
					title={t("charging.charger_pricing")}
					text={price}
					valueChange={setPrice}
					onlyNumbers={true}
					hasProps={
						<WalletIcon
							stroke={ColorScheme.darkGrey}
							height={26}
							strokeWidth={2}
						/>
					}
					removeIcon={isDesktop ? false : true}
					endAdornment={t("charging.price_label")}
				/>

				<TextFieldSelect
					options={TaxPercentages}
					selected={String(tax)}
					label={t("charging.charger_tax")}
					valueChange={setTax}
					removeIcon={isDesktop ? false : true}
					hasProps={<TaxIcon stroke={ColorScheme.darkGrey} />}
				/>
			</div>

			<div style={{ flex: 1 }} />

			<div
				style={{
					display: "flex",
					width: "100%",
					margin: "auto",
					gap: "20px"
				}}
			>
				<BigButton 
					action={handleDrawerClose}
					borderColor={ColorScheme.buttonPrimary}
					textColor={ColorScheme.buttonPrimary}
					text={t("buttons.cancel")}
				/>
				<BigButton 
					action={handleSave}
					backgroundColor={ColorScheme.buttonPrimary}
					textColor={ColorScheme.textPrimary}
					text={t("buttons.save")}
				/>

			</div>
		</div>
	);
};
